if (!customElements.get("image-banner")) {
  customElements.define(
    "image-banner",
    class ImageBanner extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute("data-variant-banner-enabled")) return;

        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.variantImages = Array.from(
          this.querySelectorAll("[data-variant-banner-image]"),
        );
        this.fallbackBanner = this.querySelector("[data-variant-banner-fallback]");
        this.productHandle = this.dataset.productHandle || "";

        this.syncBanner(this.dataset.initialVariantId || "");
        window.addEventListener("variantChangeEnd", this.handleVariantChange);
      }

      disconnectedCallback() {
        window.removeEventListener("variantChangeEnd", this.handleVariantChange);
      }

      handleVariantChange(event) {
        const variantOptions = event.target;
        if (!(variantOptions instanceof HTMLElement)) return;
        if (variantOptions.tagName.toLowerCase() !== "variant-options") return;
        if (
          this.productHandle &&
          variantOptions.dataset.productHandle !== this.productHandle
        ) {
          return;
        }

        const activeVariantId =
          variantOptions.dataset.variantId ||
          variantOptions.currentVariant?.id ||
          "";

        this.syncBanner(String(activeVariantId));
      }

      syncBanner(activeVariantId) {
        const normalizedVariantId = String(activeVariantId || "");
        let hasMatchingBanner = false;

        this.variantImages.forEach((bannerImage) => {
          const isActive =
            normalizedVariantId !== "" &&
            bannerImage.dataset.variantId === normalizedVariantId;

          bannerImage.hidden = !isActive;
          if (isActive) hasMatchingBanner = true;
        });

        // Fall back to the section's default hero when a variant has no banner image.
        if (this.fallbackBanner) {
          this.fallbackBanner.hidden = hasMatchingBanner;
        }
      }
    },
  );
}
